"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = require("react");
const useOnLoad = (control, events, flagPageFocused) => {
    (0, react_1.useEffect)(() => {
        if (events
            && events.onLoad
            && (flagPageFocused === undefined
                || flagPageFocused === true)) {
            events.onLoad();
        }
    }, [control.id, flagPageFocused]);
};
exports.default = useOnLoad;
